import PropTypes from 'prop-types'
import React from 'react'

import classNames from 'classnames'
import Button from '../button'

import Typography from '../typography'
import styles from '../../../styles/bantrab/components/card.module.scss'
import Card from './index'
import Icon from '../icon'
import DownloadFullColorIcon from '../icon/download-full-color.svg'

import Users from '../../bantrab/icon/users.svg'

import Star from '../icon/star.svg'
import ArrowRight from '../../bantrab/icon/arrow-right.svg'

const CursoMediun = ({ teacher, title, category, user, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {

    [styles.recursoMediun]: true,
    [styles.card]: true
  })

  return (
    <div {...attrs}>
      <Card.Media
        solid
        className={'bg-green-500 flex-col w-full'}
        background={'black'}
        widgetLeft={
          <div className={'flex flex-row  mt-4 ml-4 items-center'}>
            <Typography className={'text-white mr-10'}>
              <Icon

                className={'mr-2'}
                svg={Users}
              />
              {user}
            </Typography>
            <Typography className={'text-white'} size={'three'}>
              <Icon
                size={24}
                className={'mr-2 text-yellow-500'}
                svg={Star} />
              {category}
            </Typography>
          </div>

        }
        widgetRight={
          <Typography
            type={'bold'}
            size={'three'}
            className={'flex  items-center justify-center w-full h-44'}>
            <Icon
              width='56'
              height='56'
              svg={DownloadFullColorIcon}
            />
          </Typography>
        }
      />
      <Card.Body>

        <div className="ml-4 mr-16  mt-4 max-w-lg">
          <Typography
            type={'bold'}
            size={'four'}
            className={'text-$black '}
          >
            {title}
          </Typography>
          <Typography
            type={'regular'}
            size={'three'}
            className={'mb-4 mt-3 text-$black font-normal'}
          >
            {teacher}
          </Typography>
        </div>
        <Button
          className={'w-full'}
          arrow
          background
          href="https://www.google.com"
          iconRight
          target="_blank"

        >
          Unete ahora
          <Icon className={'ml-2'} size={24} svg={ArrowRight} />
        </Button>

      </Card.Body>

    </div>// end div principal
  )
}

CursoMediun.propTypes = {
  teacher: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  user: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.node])

}

export default CursoMediun
